<template>
  <div>
    <table>
      <colgroup>
        <col style="width:5mm;" />
        <col style="width:20mm;" />
        <col style="width:145mm;" />
        <col style="width:8mm;" />
        <col style="width:10mm;" />
        <col style="width:10mm;" />
        <col style="width:8mm;" />
        <col style="width:40mm;" />
        <col style="width:10mm;" />
        <col style="width:20mm;" />
        <col style="width:65mm;" />
        <col style="width:65mm;" />
      </colgroup>
      <thead>
        <tr>
          <th rowspan="2">No</th>
          <th rowspan="2">分類</th>
          <th rowspan="2">質問</th>
          <th rowspan="2">本人</th>
          <th colspan="2">平均</th>
          <th rowspan="2">取上項目</th>
          <th>平均点分布</th>
          <th class="first-row">標準</th>
          <th rowspan="2">点数分布</th>
          <th colspan="2">コメント</th>
        </tr>
        <tr>
          <th>協力者</th>
          <th>差分</th>
          <th>
            本人
            <div class="v-square"></div>協力者
            <div class="v-diamond"></div>
          </th>
          <th class="second-row">偏差</th>
          <th>+</th>
          <th>-</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, i) in items"
          :key="i"
          :class="{'first-line-of-category':isFirstLineOfCategory(i)}"
        >
          <td>{{item.id}}</td>
          <td>{{item.category}}</td>
          <td>{{item.question}}</td>
          <td class="text-center">{{item.self}}</td>
          <td class="text-right">{{item.meanScore}}</td>
          <td class="text-right" :style="{color: selectTextColorByScore(item.diffSelfAndmeanScore)}">{{item.diffSelfAndmeanScore}}</td>
          <td></td>
          <td>
            <ho-bar-chart
              :forPrint="false"
              class="chart1"
              :value="item.meanScore"
              :marker="item.self"
              :chartWidth="135"
              :ops="ops"
              :isScaleDisplayed="i==0"
            />
          </td>
          <td class="text-right" >{{item.sdScore}}</td>
          <td>
            <bar-chart
              :forPrint="false"
              class="chart2"
              :values="item.frequency"
              :markers="item.self != undefined ? [item.self - 1] : []"
            />
          </td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import BarChart from "@/components/result_print/bar_chart.vue";
import HoBarChart from "@/components/result_print/horizontal_bar_chart.vue";
import { mean, standardDeviation, max } from "simple-statistics";
export default {
  components: { BarChart, HoBarChart },
  props: {
    values: {
      required: true
    },
    ops: {
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    items() {
      return this.values.map(v => {
        const avg = this.round(mean(v.score), 2);
        return {
          id: v.id,
          category: v.category,
          question: v.question,
          self: v.self,
          boss: v.boss,
          score: v.score,
          meanScore: avg,
          diffSelfAndmeanScore: this.round(avg - v.self, 2),
          sdScore: this.round(standardDeviation(v.score), 2),
          frequency: this.frequency(v.score)
        };
      });
    }
  },
  methods: {
    frequency(score) {
      let dist = Array(this.ops.length).fill(0);
      score.forEach(e => (dist[e - 1] = dist[e - 1] + 1));
      return dist;
    },
    round(value, demical) {
      const n = Math.pow(10, demical);
      return (Math.round(value * n) / n).toFixed(demical);
    },
    isFirstLineOfCategory(index) {
      return (
        index == 0 ||
        this.items[index].category != this.items[index - 1].category
      );
    },
    selectTextColorByScore(score){
      if(isNaN(score)){return false}

      const absScore = Math.abs(score)
      if(absScore <1.5){
        return false
      }else if(absScore < 2.0){
        return 'darkorange'
      }else{
        return 'red'
      }

    },
  }
};
</script>
<style lang="scss" scoped>
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
  padding-right: 3px;
}
table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 400mm;
  height: 220mm;
  td,
  th {
    border-collapse: collapse;
    border: 1px solid rgba(0, 0, 0, 0.5);
    font-size: 8px;
  }
  .first-line-of-category {
    td,
    th {
      border-top: 2px solid rgba(0, 0, 0, 0.5);
    }
  }
  td {
    word-wrap: break-word;
    padding: 1pt;
  }
  tr {
    height: 3mm;
    white-space: normal;
  }
}
th.first-row {
  border-bottom: none;
}
th.second-row {
  border-top: none;
}

h3 {
  margin: 5mm 0;
}
.v-square {
  -webkit-print-color-adjust: exact;
  background-color: red !important;
  width: 4px;
  height: 4px;
  margin: 2px;
  display: inline-block;
}
.v-diamond {
  -webkit-print-color-adjust: exact;
  background-color: blue !important;
  width: 3px;
  height: 3px;
  margin: 2px;
  display: inline-block;
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-transform-origin: 0 100%;
  -moz-transform-origin: 0 100%;
  -ms-transform-origin: 0 100%;
  -o-transform-origin: 0 100%;
  transform-origin: 0 100%;
}
</style>